export default "__VITE_ASSET__4d295454__"